// this area doesn't have a navigation item in the navbar

import type { AreaNavigationProps } from '@backoffice-frontend/patterns'

export const UpdatesAreaNavigation = (_props: AreaNavigationProps) => {
  return null
}
